"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuWithChild = exports.Menu = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var faChevronRight_1 = require("@fortawesome/free-solid-svg-icons/faChevronRight");

exports.Menu = utils_2.forwardRef(function Grid(props, ref) {
  var childLabel = props.childLabel,
      selected = props.selected,
      reduced = props.reduced,
      onSelect = props.onSelect,
      arrows = props.arrows,
      rest = __rest(props, ["childLabel", "selected", "reduced", "onSelect", "arrows"]);

  var menuContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmin-height: 2.5rem;\n\t\tdisplay: flex;\n\t\tjustify-content: ", ";\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\tpadding-left: ", ";\n\t\tfont-size: 0.875rem;\n\t\tcursor: pointer;\n\t\tbackground: ", ";\n\t\tbox-shadow: ", ";\n\t\tborder-radius: 0.5rem;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t}\n\t"], ["\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmin-height: 2.5rem;\n\t\tdisplay: flex;\n\t\tjustify-content: ", ";\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t\tpadding-left: ", ";\n\t\tfont-size: 0.875rem;\n\t\tcursor: pointer;\n\t\tbackground: ", ";\n\t\tbox-shadow: ", ";\n\t\tborder-radius: 0.5rem;\n\n\t\t&:hover {\n\t\t\tbackground: ", ";\n\t\t}\n\t"])), reduced ? 'center' : 'flex-start', foundation_1.colors.white, reduced ? '0px' : '2rem', selected ? foundation_1.colors.secondary.vDarkGrey : 'transparent', selected ? '0 5px 10px rgba(66, 85, 99, .25)' : 'none', foundation_1.colors.secondary.vDarkGrey);
  var menuIcon = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\twidth: 30px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t"], ["\n\t\twidth: 30px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: ", ";\n\t"])), foundation_1.colors.primary.green);
  var menuLabel = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t"], ["\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t"])));
  var meta = {};

  if (onSelect) {
    meta.onClick = function () {
      return onSelect();
    };
  }

  return (0, _core.jsx)(lseds_1.lseds.div, _extends({
    ref: ref,
    css: menuContainer
  }, meta, rest), arrows && (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: menuIcon
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: faChevronRight_1.faChevronRight
  })), !reduced && (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: menuLabel
  }, childLabel));
});
exports.MenuWithChild = utils_2.forwardRef(function Grid(props, ref) {
  var children = props.children,
      label = props.label,
      icon = props.icon,
      width = props.width,
      reduced = props.reduced,
      arrows = props.arrows,
      _a = props.expanded,
      expanded = _a === void 0 ? false : _a;

  var _b = React.useState(expanded),
      visible = _b[0],
      setVisible = _b[1];

  var menuWithChildContainer = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\twidth: ", ";\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t\tbackground: ", ";\n\t\tbox-shadow: ", ";\n\t\tborder-radius: ", ";\n\t\tpadding: ", ";\n\t\tcolor: ", ";\n\t"], ["\n\t\twidth: ", ";\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t\tbackground: ", ";\n\t\tbox-shadow: ", ";\n\t\tborder-radius: ", ";\n\t\tpadding: ", ";\n\t\tcolor: ", ";\n\t"])), width ? reduced ? '40px' : width : '100%', children ? foundation_1.colors.secondary.darkGrey : 'transparent', children ? '0 8px 8px rgba(0, 0, 0, .15)' : 'none', reduced ? '0px' : '0.5rem', reduced ? '0px' : '0.5rem', foundation_1.colors.white);
  var menuData = core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tpadding: 0.5rem;\n\t\tfont-size: 1rem;\n\t\tcursor: pointer;\n\t"], ["\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tpadding: 0.5rem;\n\t\tfont-size: 1rem;\n\t\tcursor: pointer;\n\t"])));
  var menuDataIcon = core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\twidth: 30px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t"], ["\n\t\twidth: 30px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t"])));
  var menuDataLabel = core_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t"], ["\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t"])));
  var content = core_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t"], ["\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: menuWithChildContainer
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: menuData,
    onClick: function onClick() {
      return setVisible(!visible);
    }
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: menuDataIcon
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: icon
  })), !reduced && (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: menuDataLabel
  }, label)), visible && children && (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: content
  }, React.Children.map(props.children, function (child, index) {
    // @ts-ignore
    return React.cloneElement( // @ts-ignore
    child, {
      reduced: reduced,
      arrows: arrows
    });
  })));
});

if (utils_1.isDev) {
  exports.MenuWithChild.displayName = 'MenuWithChild';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;